import React from "react";
import Select from "react-select";

export const CustomDropdown = React.forwardRef((props, ref) => {
  return (
    <Select
      ref={ref}
      name={props.name}
      className={props.className}
      placeholder={props.placeholder}
      options={props.options}
      isSearchable={true}
      isClearable={true}
      defaultValue={props.defaultValue ? props.defaultValue : false}
      onChange={(e) => {
        if (props.valueChanged) {
          props.valueChanged(e);
        }
      }}
      noOptionsMessage={(object) => {
        if (object.inputValue.trim().length === 0) {
          return null;
        }
        return "No matches found";
      }}
      styles={{
        dropdownIndicator: () => ({
          color: "#fff"
        }),
        singleValue: () => ({
          color: "#fff",
          height: "auto",
          width: "100%"
        }),
        container: () => ({
          position: "relative",
          "&.error-dropdown": {
            border: "1px solid #e74c3c",
            borderRadius: "12px"
          }
        }),
        valueContainer: () => ({
          display: "flex",
          alignItems: "center",
          width: "100%"
        }),
        input: () => ({
          color: "#fff",
          width: "min-content"
        }),
        indicatorSeparator: () => ({
          display: "none"
        }),
        placeholder: () => ({
          color: "#fff"
        }),
        clearIndicator: () => ({
          display: "none"
          // color: "#fff",
          // marginRight: "20px",
          // cursor: "pointer"
        }),
        control: () => ({
          background: "#293659",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          borderRadius: "12px",
          fontFamily: "proxima-nova, sans-serif",
          fontStyle: "normal",
          fontWeight: "600",
          width: props.width ? props.width : "100%"
        }),
        menu: (base) => ({
          ...base,
          background: "#293659",
          color: "#fff",
          position: "absolute",
          zIndex: 50,
          borderRadius: "12px"
        }),
        option: () => ({
          padding: "10px 15px",
          "&:hover": {
            background: "#04123f"
          }
        })
      }}
    />
  );
});
